// extracted by mini-css-extract-plugin
export default {"truncatedText":"TruncatableText-TruncatableText__truncatedText--wdxhC"};